/**
 * Tömb generálás.
 * @template T
 * @param {ArrayLike<T>} arrayLike - Tömb.
 * @returns {T[]} Tömb.
 */
module.exports.from = function from (arrayLike) {
  return Array.from(arrayLike)
}
